import React from 'react'
import BankService from '../Service/bankService'
import Overview from './Overview'
import { config } from '../Config/config'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import bankService from '../Service/bankService';

export default class root extends React.Component {

    BankModel = {
        name: "",
        va_code:"",
        create_by: "",
        create_on: "",
        modified_by: "",
        modified_on: "",
        deleted_by: "",
        deleted_on: "",
        is_delete: false
    }



    constructor() {
        super()
        this.state = {
            List: [],
            Model: this.BankModel,
            setShow: false,
            Mode: "",
            setShowDel: false,
            errors: {},
            count: 0,
            TotalPage: 0,
            filter: {
                search: "",
                sort: "name",
                order:"1", 
                page: '1',
                pagesize: '5'
            }
        }
    }

    loadList = async () => {
        const respon = await BankService.getAllFilterBank(this.state.filter)
        const responCount = await BankService.countBank()

        if (respon.success) {

            let count = responCount.result.count
            this.setState({
                List: respon.result,
                TotalPage: Math.ceil(count / this.state.filter.pagesize)
            })
        }
        console.log(this.state.List)
    }

    componentDidMount() {
        this.loadList()
    }

    createHandler = () => {
        this.setState({
            Mode: "Tambah",
            setShow: true,
            Model: this.BankModel
        })
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            setShow: false
        })
    }

    cancelHandlerDel = () => {
        this.setState({
            setShowDel: false
        })
    }

    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            }
        })
    }


    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: checked
            }
        })
    }

    saveHandler = async () => {
        if (await this.handleValidation()) {
            if (this.state.Mode == "Ubah") {
                const respon = await BankService.EditBank(this.state.Model)
                if (respon.success) {
                    this.loadList()
                    this.setState({
                        Model: this.BankModel,
                        setShow: false
                    })
                }
            }
            else {
                this.setState({
                    create_by: localStorage.getItem(config.userid)
                })
                const respon = await BankService.addBank(this.state.Model)
                console.log(respon)
                if (respon.success) {
                    alert("Success Save Data")
                    this.loadList()
                    this.setState({
                        Model: this.BankModel,
                        setShow: false
                    })

                }
            }
        }
    }


    editHandler = async (id) => {
        const respon = await BankService.getBankID(id)
        console.log(respon)
        this.setState({
            Mode: "Ubah",
            setShow: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    softDeleteHandler = async (id) => {
        const respon = await BankService.getBankID(id)
        this.setState({
            setShowDel: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    saveHandlerDel = async () => {
        if (this.handleValidation()) {
            const respon = await BankService.softDeleteBank(this.state.Model)
            console.log(respon)
            if (respon.success) {
                alert("Data Delete Success")
                this.loadList()
                this.setState({
                    Model: this.BankModel,
                    setShowDel: false
                })
            }
        }
    }

    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    handleValidation = async ()=> {
        let fields = this.state.Model
        let errors = {}
        let formIsValid = true;

        if (!fields["name"]) {  
            formIsValid = false
            errors["name"] = "Name cannot be empty"
        }

        if (!fields["va_code"]) {
            formIsValid = false
            errors["va_code"] = "VA Code cannot be empty"
        }

        if(fields["va_code"].length > 4){
            formIsValid = false
            errors["va_code"] = "VA Code only accept 4 numeric number"
        }

        this.setState({ errors: errors })
    
        return formIsValid
    }

    renderPagination() {
        let item = []
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        return (
            <Pagination>{item}</Pagination>
        )
    }

    orderHandler = (order) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["order"]: order
            }
        }, () => this.loadList())
    }

    sortHandler = (sort) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["sort"]: sort
            }
        }, () => this.loadList())
    }

    pageSizeHandler = (size) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["pagesize"]: size
            }
        }, () => this.loadList())
    }

    changePageHandler = (number) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            }
        }, () => this.loadList())
    }




    render() {
        const { List, Model, setShow, setShowDel, errors } = this.state

        return (
            <div class="container">
                <div class="text-center mb-3">
                    <h2>Bank</h2>
                </div>
                <div class="input-group col-5 mb-1 float-left">
                    <input class="form-control rounded-left" type="text" placeholder="Search" onChange={this.filterHandler("search")} />
                    <div class="input-group-append" onClick={this.loadList}>
                        <button class="btn btn-primary rounded-right" type="button">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
                <button type="button" class="btn btn-success mb-3 float-right" onClick={() => this.createHandler()}>ADD Bank</button>
                <div className="input-group-append">

                    <button type="button" class="btn btn-primary dropdown-toggle " data-toggle="dropdown" aria-expanded="true">
                        Show Data
                    </button>
                    <ul class="dropdown-menu">
                        <li><a href="#" onClick={() => this.pageSizeHandler('5')} className="dropdown-item">5</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('10')} className="dropdown-item">10</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('20')} className="dropdown-item">20</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('30')} className="dropdown-item">30</a></li>
                    </ul>
                    <div class= "btn-group">
                    <button type="button" style = {{marginLeft:"20px"}} class="btn btn-primary dropdown-toggle " data-toggle="dropdown" aria-expanded="true">
                        Sort
                    </button>
                    <ul class="dropdown-menu">
                        <li><a href="#" onClick={() => this.sortHandler('name')} className="dropdown-item">Name</a></li>
                        <li><a href="#" onClick={() => this.sortHandler('va_code')} className="dropdown-item">Va Code</a></li>
                    </ul>
                  </div>
                  <div class= "btn-group" >
                    <button type="button" style = {{marginLeft:"20px"}} class="btn btn-primary dropdown-toggle " data-toggle="dropdown" aria-expanded="true">
                        Order
                    </button>
                    <ul class="dropdown-menu" >
                        <li><a href="#" onClick={() => this.orderHandler('1')} className="dropdown-item" >ASC</a></li>
                        <li><a href="#" onClick={() => this.orderHandler('-1')} className="dropdown-item">DSC</a></li>
                    </ul>
                  </div>
                </div>
                <table class="table table-light">
                    <thead>
                        <tr class="text-center">

                            <th scope="col">Name</th>
                            <th scope="col">Va Code</th>
                            <th scope="col">Action</th>

                        </tr>
                    </thead>
                    <tbody>
                        {
                            List.map(data => {
                                return (
                                    <tr class="text-center">
                                        <td>{data.name}</td>
                                        <td>{data.va_code}</td>
                                        <td><button class="btn btn-primary " onClick={() => this.editHandler(data._id)} style = {{backgroundColor:"orange",marginRight:"5px"}}><i class = "fa fa-pencil" style = {{color:"white"}}/></button>
                                            <button class="btn btn-danger" onClick={() => this.softDeleteHandler(data._id)}><i class = "fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>

                <div class="float-right">
                    {this.renderPagination()}
                </div>

                <Overview
                    changeHandler={this.changeHandler}
                    checkedHandler={this.checkedHandler}
                    saveHandler={this.saveHandler}
                    Model={Model}
                    setShow={setShow}
                    cancelHandler={this.cancelHandler}
                    // handleChange={this.handleChange}
                    errors={errors}
                    Mode={this.state.Mode}
                    setShowDel={setShowDel}
                    cancelHandlerDel={this.cancelHandlerDel}
                    saveHandlerDel={this.saveHandlerDel}
                    handleValidation={this.handleValidation}
                />
            </div>
        )
    }
}